import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ExamResultDetailsLayer from "../components/ExamResultDetailsLayer";

const ExamResultDetailsPage = () => {
  return (
    <MasterLayout>
      <ExamResultDetailsLayer />
    </MasterLayout>
  );
};

export default ExamResultDetailsPage;
